module.exports = __webpack_public_path__ + "img/dcpower_logo_login.ee27677c.png";